import StoreIcon from '@mui/icons-material/Store';
import ScienceIcon from '@mui/icons-material/Science';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import AssignmentReturnedIcon from '@mui/icons-material/AssignmentReturned';

const icoMenu = {
    StoreIcon,
    ScienceIcon,
    PrecisionManufacturingIcon,
    AssignmentReturnedIcon
};

// ==============================|| COMPRAS MENU ITEMS - DOCTOR ||============================== //

const compra = {
    id: 'compra',
    title: '',
    type: 'group',
    children: [
        {
            id: 'productosMainMenu',
            title: 'Compras',
            type: 'collapse',
            icon: icoMenu.StoreIcon,
            children: [
                {
                    id: 'comprasProductos',
                    title: 'Productos',
                    type: 'collapse',
                    icon: icoMenu.PrecisionManufacturingIcon,
                    children: [
                        {
                            id: 'parametros_inspeccionar_recepcion',
                            title: 'Parametros a inspeccionar',
                            type: 'item',
                            url: '/user/new-recepcion-productos-inspeccion'
                        },
                        {
                            id: 'lista_recepcion_productos',
                            title: 'Lista Recepciones',
                            type: 'item',
                            url: '/user/list-recepcion-productos'
                        }
                    ]
                },
                {
                    id: 'devolucionesCompras',
                    title: 'Devoluciones y Descuentos en Compras',
                    icon: icoMenu.AssignmentReturnedIcon,
                    type: 'item',
                    url: '/user/devoluciones-compras/0'
                },
                {
                    id: 'direccionTecnica',
                    title: 'Dirección Técnica',
                    type: 'collapse',
                    icon: icoMenu.ScienceIcon,
                    children: [
                        {
                            id: 'informeProductosCuarentena',
                            title: 'Informe de productos en Cuarentena',
                            type: 'item',
                            url: '/user/informe-productos-cuarentena'
                        },
                        {
                            id: 'listInformesProductosAprobadosRechazados',
                            title: 'Lista informes productos aprobados rechazados',
                            type: 'item',
                            url: '/user/list-informes-productos-aprobados-rechazados'
                        },
                        {
                            id: 'aprobarProductos',
                            title: 'Aprobar Productos',
                            type: 'item',
                            url: '/user/list-compras-aprobar'
                        }
                    ]
                }
            ]
        }
    ]
};

export default compra;
